var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "url(#paint0_linear_208_635)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7829 15.0255C26.4048 13.2703 25.0226 12.3497 24.9644 12.3113L24.7644 12.1795V15.1308C24.7644 15.5611 24.3929 15.91 23.9347 15.91C23.4765 15.91 23.105 15.5611 23.105 15.1308V13.8841C23.105 10.4105 20.7768 8.21409 20.1851 7.61599C20.1851 7.61599 19.3247 6.808 18.8945 6.404C18.4643 6 18.0341 6 18.0341 6L18.0707 7.17294C18.0431 9.14043 16.1088 12.0263 12.624 15.2989C10.0753 17.6923 8.99159 19.9652 9.00005 22.8987C9.0079 25.6056 10.1622 28.1562 12.2504 30.0806C14.2975 31.9671 16.9681 33 19.7881 33C19.8464 33 19.9051 32.9996 19.9635 32.9987C22.8073 32.9555 25.4736 31.8829 27.4711 29.9783C29.471 28.0715 30.5723 25.5473 30.5723 22.8707C30.5723 20.0623 29.6077 17.3494 27.7829 15.0255Z",
    fill: "url(#paint1_linear_208_635)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_208_635",
    x1: 53.9487,
    y1: 32.705,
    x2: 37.4385,
    y2: 52.6597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_208_635",
    x1: 21.492,
    y1: 33,
    x2: 18.4009,
    y2: 5.96335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2E00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.b73e8ddb916dadf3ce4f1bf7fffea231.svg";
export { ForwardRef as ReactComponent };